import axiosInstance from './axiosInstance'

export interface CustomerNote {
  id:         string
  customerId: string
  content:    string
  createdBy:  { id: string; name: string; email: string; avatarUrl: string | null } | null
  createdAt:  string
  updatedAt:  string
}

export const customerNotesApi = {
  getAll: (customerId: string) =>
    axiosInstance.get<{ data: CustomerNote[] }>(`/customers/${customerId}/notes`).then(r => r.data.data),

  create: (customerId: string, content: string) =>
    axiosInstance.post<{ data: CustomerNote[] }>(`/customers/${customerId}/notes`, { content }).then(r => r.data.data),

  update: (customerId: string, noteId: string, content: string) =>
    axiosInstance.put<{ data: CustomerNote[] }>(`/customers/${customerId}/notes/${noteId}`, { content }).then(r => r.data.data),

  delete: (customerId: string, noteId: string) =>
    axiosInstance.delete(`/customers/${customerId}/notes/${noteId}`),
}
